export * from "./auth";
export * from "./dashboard";
export * from "./investors";
export * from "./transactions";
export * from "./history";
export * from "./appEssentials";
export * from "./empanelment";
export * from "./newinvestor";
export const ALL = "A";
export const FAVOURITE = "FAV";
export const RECENT = "R";
export const YES = "Y";
export const NO = "N";
export const PANALL = "ALL";
export const TRUE = "T";
export const FALSE = "F";
export const AUTHORIZATION_PENDING = "P";
export const AUTHORIZATION_APPROVED = "A";
export const AUTHORIZATION_EXPIRED = "E";
export const FMPS_MATURITY = "FMPS_MATURITY";
export const SIPS = "SIPS";
export const PHYSICAL_TRANSACTIONS = "PHYSICAL_TRANSACTIONS";
export const INVESTMENTS = "INVESTMENTS";
export const UPCOMING_SIP = "UPCOMING_SIP";
export const EXISTING = "EXISTING";
export const NEW = "NEW";
export const NEWP = "NEWP";
export const PURCHASE = "P";
export const SIP_TRANS_TYPE = "I";
export const REQ_BY = "a";
export const REGULAR = "Regular";
export const PAYMENT_TYPE = "DCB";
export const NEW_PURCHASE = "NEW_PURCHASE";
export const ADDITIONAL_PURCHASE = "ADDITIONAL_PURCHASE";
export const PARTIAL = "PARTIAL";
export const FULL = "FULL";
export const UNITS = "UNITS";
export const AMOUNT = "AMOUNT";
export const REDEMPTION = "REDEMPTION";
export const U = "U";
export const SWITCH = "SWITCH";
export const SWP = "SWP";
export const STP = "STP";
export const SIP = "SIP";
export const PHYSICAL_NEW = "new";
export const PHYSICAL_ADD = "add";
export const PHYSICAL_RED = "red";
export const PHYSICAL_SWITCH = "swop";
export const PHYSICAL_SIP = "isip";
export const GRAPH = "GRAPH";
export const TABLE = "TABLE";
export const PAYMENT_MODE = "PM";
export const INVESTMENT_FREQUENCY = "IF";
export const SIP_DAY = "D";
export const START_LOADER = "START_LOADER";
export const STOP_LOADER = "STOP_LOADER";
export const INACTIVE_INVESTORS = "INACTIVE_INVESTORS";
export const ACTIVE_INVESTORS = "ACTIVE_INVESTORS";
export const NEW_INVESTORS = "NEW_INVESTORS";
export const EXPIRING_NEXT_MONTH = "EXPIRING_NEXT_MONTH";
export const CLOSED_THIS_MONTH = "CLOSED_THIS_MONTH";
export const SIP_INVESTMENTS = "SIP_INVESTMENTS";
export const CWS = "CWS";
export const CWOS = "CWOS";

export const GET_NOMINEE_DETAILS = "GET_NOMINEE_DEATILS";
export const GET_NOMINEE_DETAILS_SUCESS = "GET_NOMINEE_DETAILS_SUCESS";
export const GET_NOMINEE_DEATILS_FAILED = "GET_NOMINEE_DEATILS_FAILED";
export const GET_BANK_DETAILS_SUCESS = "GET_BANK_DETAILS_SUCESS";
export const GET_BANK_DETAILS = "GET_BANK_DETAILS";
export const GET_BANK_DETAILS_FAILED = "GET_BANK_DETAILS_FAILED";
export const STORE_ADDRESS_SUCESS = "STORE_ADDRESS_SUCESS";
export const STORE_CAMS_DETAILS = "STORE_CAMS_DETAILS";


